import style from './LuckyHomePage.css';
import LuckyHomeAppBar from '../../components/LuckyHome/LuckyHomeAppBar/LuckyHomeAppBar';
import LuckyEmptyCardsList from '../../components/LuckyHome/LuckyEmptyCardsList/LuckyEmptyCardsList';
import { useEffect, useState } from 'preact/hooks';
import LuckyUserHasCardsView from './LuckyUserHasCardsView';
import useTranslation from '../../localization/i18n.context';
import useConfig from '../../config/config.context';
import { renderIf } from '../../utils/render.utils';
import LoadingScreen from '../../components/shared/LoadingScreen/LoadingScreen';
import CaasStorageKeys from '../../constants/caas.storage.keys';
import CardService from '../../services/card.service';
import { TrackingEvent } from '../../sdk/tracking.event';
import LuckyTryAgain from '../../components/LuckyHome/LuckyTryAgain/LuckyTryAgain';
import { ConsoleEvent } from '../../sdk/console.event';
import SettingsService from '../../services/settings.service';
import { NotificationsFlow } from '../../constants/notifications-flow.constant';
import CardStatus from '../../constants/card.status';
import __caas__ from '../../sdk/__caas__';

export default function LuckyHomePage() {
  const { config, updateConfigByKey } = useConfig();
  const [isLoading, setIsLoading] = useState(true);
  const [showTryAgain, setShowTryAgain] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [sendMoneyButtonEnabled, setSendMoneyButtonEnabled] = useState(false);
  const [notificationsFlow, setNotificationsFlow] = useState(
    NotificationsFlow.NATIVE,
  );
  const [lendingButtonEnabled, setLendingButtonEnabled] = useState(false);

  const { t } = useTranslation();
  const [cards, setCards] = useState([]);

  async function loadHomeData(config) {
    setIsLoading(true);

    const isLoggedIn =
      config[CaasStorageKeys.CONFIG] &&
      config[CaasStorageKeys.CONFIG].token &&
      config[CaasStorageKeys.CONFIG].token != null &&
      config[CaasStorageKeys.CONFIG].token !== '' &&
      config[CaasStorageKeys.CONFIG].token !== 'null';

    setIsLoggedIn(isLoggedIn);

    if (!isLoggedIn) {
      ConsoleEvent.log(`user is not logged in. Skipping loadHomeData`);
      setIsLoading(false);
      return;
    }

    try {
      const [settingsResponse, cardListResponse] = await Promise.all([
        SettingsService.getHome(),
        CardService.list(),
      ]);

      setSendMoneyButtonEnabled(
        settingsResponse.data.sendMoneyButtonEnabled &&
          cardListResponse.data.find(card =>
            [CardStatus.ACTIVE, CardStatus.LOCKED].includes(card.status),
          ),
      );
      setNotificationsFlow(settingsResponse.data.notificationsButtonFlow);
      setLendingButtonEnabled(settingsResponse.data.lendingButtonEnabled);

      if (cardListResponse) {
        setCards(cardListResponse.data || []);
      } else {
        setCards([]);
      }

      setShowTryAgain(false);
      TrackingEvent.trigger(
        TrackingEvent.Events.DISCOVER_LOAD_FEED,
        TrackingEvent.Sources.CAAS,
      );
    } catch (e) {
      ConsoleEvent.log(`Something went wrong ${e}`);
      ConsoleEvent.log(
        `Current config: ${JSON.stringify(
          __caas__.config[CaasStorageKeys.CONFIG],
        )}`,
      );
      TrackingEvent.trigger(
        TrackingEvent.Events.DISCOVER_LOAD_FEED_ERROR,
        TrackingEvent.Sources.CAAS,
      );
      setShowTryAgain(true);
    } finally {
      setIsLoading(false);
    }
  }

  const handleHomeRefresh = e => {
    updateConfigByKey(e.detail.eventData)
      .then(newConfig => {
        ConsoleEvent.log(
          `Sending loadHomeData with new config. Config new is: ${newConfig}`,
        );
        loadHomeData(newConfig);
      })
      .catch(e => {
        ConsoleEvent.log(`Error occurred updating the config keys. ${e}`);
        setIsLoading(false);
        setShowTryAgain(true);
      });
  };

  // update home page content on request
  useEffect(() => {
    loadHomeData(config);

    document.addEventListener(
      window.__CAAS__.events.refreshPage,
      handleHomeRefresh,
    );

    return () => {
      document.removeEventListener(
        window.__CAAS__.events.pressBack,
        handleHomeRefresh,
      );
    };
  }, []);

  return (
    <>
      <LuckyHomeAppBar
        className="fixed-bar"
        title={!showTryAgain ? t('Cards') : ''}
        showManageBalance={isLoggedIn && cards.length > 0 && !showTryAgain}
        notificationsFlow={notificationsFlow}
      />

      {renderIf(
        showTryAgain,
        <LuckyTryAgain
          onButtonClick={() => {
            return loadHomeData(config);
          }}
        />,
      )}

      {renderIf(
        !showTryAgain,
        <>
          {renderIf(!isLoggedIn, <LoadingScreen />)}
          {renderIf(
            isLoggedIn,
            <div className={style.container}>
              {renderIf(
                cards.length,
                <LuckyUserHasCardsView
                  cards={cards}
                  sendMoneyButtonEnabled={sendMoneyButtonEnabled}
                  lendingButtonEnabled={lendingButtonEnabled}
                />,
              )}

              {renderIf(
                !cards.length,
                <LuckyEmptyCardsList isLoggedIn={isLoggedIn} />,
              )}
            </div>,
          )}
        </>,
      )}

      {renderIf(isLoading, <LoadingScreen />)}
    </>
  );
}
